import { useEffect, useState } from "react";
import "./Home.css";
import { Link, useNavigate } from "react-router-dom";
// import homefig from "../../Images/Home Figure.png";
// import homefig1 from "../../Images/homefig1.png";
// import homefig2 from "../../Images/homefig2.png";
// import homefig3 from "../../Images/homefig3.png";
import homefig1 from "../../Images/card.png";
import homefig2 from "../../Images/mobile.png";
// import HomeHeader from "../../Layout/HomeHeader";
import Aos from "aos";
import "aos/dist/aos.css";
import HttpClient from "../../utils/HttpClient";
import { reactLocalStorage } from "reactjs-localstorage";
import toast from "react-hot-toast";
// import CustomLoader from "../../CustomComponents/loader/CustomLoader";
// import Loader from "../../Component/Loader";
import { confirmAlert } from "react-confirm-alert";
import error from '../../Images/not-allowed-sign-isolated-on-white_f1Rzlwju_thumb-removebg-preview.png'
import SeoGeneral from '../BusinessPage/SeoGeneral';

const Home = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [show, setShow] = useState(true);

  const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  // const passWord = password.length >= 4 && password.length <= 15;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = email.trim() !== "" && password.trim() !== "";
    if (isValid) {
      // toast.success("login successfully")
      if (!email.match(mailFormat)) {
        toast.error("Invalid Email");
      } else {
        const data = {
          emailId: email,
          password: password,
        };
        const res = await HttpClient.requestData("login", "POST", data);
        if (res && res.status) {

          // if (res?.data?.suspendStatus) {
          //   setModal(true)
          //   return
          // }

          reactLocalStorage.set("userDataNeoCard", res?.data?.token);
          reactLocalStorage.set(
            "userDataNeoCardMemberStatus",
            JSON.stringify({ MemberStatus: res?.data?.memberStatus })
          );

          // return
          if (res?.data?.userName) {
            toast.success("Login Successfully");
            setEmail("");
            setPassword("");
            navigate("/profile/" + res?.data?.userName?.trim())
          } else {
            // navigate("/profile/business-user")
            navigate("/create-businesscard-profile", {
              state: { formData: { emailId: res?.data?.emailId, password: res?.data?.passwordView } },
            })
            // toast.error(<><p>No <strong>Profile Name</strong> is associated with your account.</p></>);
          }

        } else if (!res?.status && res?.data?.suspendStatus === true) {
          setModal(true)
          return
        } else {
          confirmAlert({
            customUI: ({ onClose }) => (
              <div
                style={{
                  background: '#fff',
                  padding: '20px',
                  borderRadius: '8px',
                  width: '400px',
                  maxWidth: '90%',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  fontFamily: 'Arial, sans-serif',
                  position: 'relative',
                }}
              >

                <i
                  className="fa fa-times"
                  onClick={onClose}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    cursor: 'pointer',
                    color: '#888',
                    fontSize: '18px',
                  }}
                ></i>

                {/* Title */}
                <h4
                  style={{
                    color: "#ff0000",
                    fontWeight: '400',
                    fontSize: "20px",
                    marginBottom: '10px',
                  }}
                >
                  Sorry!
                </h4>

                {/* Message */}
                <p style={{
                  color: '#000',
                  fontSize: '14px',
                  fontWeight: '500',
                  margin: '5px 0px'
                }}>
                  Incorrect username/password
                </p>
                <p style={{
                  color: '#000',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Please enter registered username and password or Reset password
                </p>

                {/* Button */}
                <div style={{
                  marginTop: '15px',
                  // textAlign: 'right' 
                }}>
                  <button
                    onClick={() => {
                      navigate("/forgotPassword");
                      onClose();
                    }}
                    style={{
                      color: '#3e84d6',
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '12px',
                      // fontWeight: 'bold'
                    }}
                  >
                    Forgot Password
                  </button>
                </div>
              </div>
            )
          })


          // navigate("/activate-neoocard");
        }
      }
    } else {
      toast.error("Please fill all the Inputs..");
    }
  };

  const handleClick = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    Aos.init();
    Aos.refresh();

    setTimeout(() => {
      setShow(false);
    }, 2000);
  }, []);

  const [modal, setModal] = useState(false)
  // MOdal Code Starts HEre
  const Modal = () => {
    return (
      <>
        <div className="home_modal_wrapper" onClick={(() => { setModal(!modal) })}></div>
        <div className="home_modal_div" >
          <i onClick={(() => { setModal(false) })} style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            fontSize: '20px',
            cursor: 'pointer',
          }} className="fa-solid fa-xmark"></i>
          <div className="error_div">
            <img src={error} />
          </div>
          <h2>Page suspended</h2>
          <h4 style={{
            fontWeight: '500'
          }}>Your Neoo Search page is suspended</h4>
          <h6 style={{
            width: '80%',
            marginInline: 'auto',
            fontSize: '16px',
            fontWeight: '400'
          }}>Your Neoo Search account has been temporarily suspended
            which mean you can’t access your Neoo search page.
            For more information Contact the Help Center
          </h6>
          <div className="d-flex justify-content-center">
            <button>
              <Link to="/lets-get-intouch" style={{
                color: 'white',
                textDecoration: 'underline'
              }}> Help Center</Link>
            </button>
          </div>

        </div>
      </>
    )
  }

  const seoMetaData = {
    title: "NeooSearch – Log In ",
    description: "Create your NeooCard to start connecting with your customers and building your business network.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "NeooSearch – Log In",
    url: process.env.REACT_APP_APPLICATION_URL + "/user-login",
    keywords: "NeooSearch, NeooCard, business network, connect with customers, digital business card, business growth",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/user-login"
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      {modal && <Modal />}
      <section className="homeBtm">
        <div className="cust_container">
          <div className="homeDiv">
            <div className="homeLeft">
              <div className="homeContent">
                <h3 className="homebighead">
                  Welcome To Our Business Community
                </h3>
                <h5 className="homeSmallHead">
                  MEET YOUR CUSTOMERS SMARTLY & BOOST YOUR BUSINESS DIGITALLY
                </h5>
                <h6 className="homepara">
                  We help people connect with opportunities. Join our people
                  accelerator program
                </h6>
              </div>

              <div className="homeForm">
                <h5 className="homeformHead">Login To Your Account</h5>
                <form action="">
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      placeholder="Email Id"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="form-group passDiv">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                    />
                    <button
                      type="button"
                      onClick={handleClick}
                      className="passEyebtn"
                    >
                      {showPassword ? (
                        <i className="fa-regular fa-eye"></i>
                      ) : (
                        <i className="fa-regular fa-eye-slash"></i>
                      )}
                    </button>
                  </div>
                  <div className="form-group HomeFormFlex ">
                    {/* <label style={{ display: "flex", alignItems: "center" }}>
                      <input type="checkbox" />
                      <span>Remember Me</span>
                    </label> */}
                    <Link to="/forgotPassword" className="HomefrgtPwd mt-3">
                      Forgot Password ?
                    </Link>
                  </div>
                  <button
                    onClick={handleSubmit}
                    type="submit"
                    className="homeloginBtn"
                  >
                    Log In
                  </button>
                </form>
              </div>
            </div>

            {/* <figure className='Homefig' data-aos="fade-right" data-aos-duration="2000">
                            <img src={homefig} alt="img" />
                        </figure> */}

            <div className="homeStruc">
              <div className="homeStrucInn"></div>
              <figure
                className="HomeFigOne homimg"
                data-aos="fade-up-right"
                data-aos-duration="1000"
              >
                <img src={homefig1} alt="img" />
              </figure>
              <figure
                className="HomeFigTwo homimg"
                data-aos="fade-in"
                data-aos-duration="1500"
              >
                <img src={homefig2} alt="img" />
              </figure>
              {/* <figure
                  className="HomeFigThree homimg"
                  data-aos="fade-in"
                  data-aos-duration="1500"
                >
                  <img src={homefig3} alt="img" />
                </figure> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
